import React from 'react'
import { Grid, Typography, Box} from '@mui/material'
import { getImageUrl } from '../utils/apiHelpers'

function Transaction({transaction, index, colors}) {
	console.log(transaction)
  return (
		<div>
			<Box display="flex">
				{transaction.image_path !== "" ?
				<img src={getImageUrl(transaction.image_path)} height="60px" width="60px" alt="Produktbild" />
				: null}
				<Grid container display="flex" justifyContent="flex-start" alignItems="center" sx={{height: "60px"}} flexGrow={1}>
					<Grid size={4}>
						<Box display="flex" flexDirection="column">
							<Typography variant="h6" color={colors.gray[100]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
								{transaction.user_name}
							</Typography>
							<Typography variant="h6" color={colors.gray[300]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
								{new Date(transaction.date).toLocaleDateString("sv-SE", {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
									hour: '2-digit',
									minute: '2-digit'
								})}
							</Typography>
						</Box>
					</Grid>
					<Grid size={4}>
						<Box display="flex" flexDirection="column">
							<Typography variant="h6" color={colors.gray[100]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
								{transaction.product_name}
							</Typography>
							<Typography variant="h6" color={colors.gray[300]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
								{transaction.amount} st
							</Typography>
						</Box>
					</Grid>
					<Grid size={4}>
						<Box display="flex" flexDirection="column">
							<Typography variant="h3" color={colors.gray[100]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
								{transaction.amount * transaction.cost} kr
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</div>
  )
}

export default Transaction